import React, {useEffect, useRef, useState} from 'react';

const Tooltip = ({content, children, disabled}) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipHeight, setTooltipHeight] = useState(0);

    const tooltipRef = useRef();
    const tooltipWrapRef = useRef();
    const handleMouseEnter = (e) => {
        if ((tooltipWrapRef.current === e.target && showTooltip) || (tooltipWrapRef.current !== e.target))
            setShowTooltip(!disabled && true);

    };

    useEffect(() => {
        if (tooltipRef.current) {
            setTooltipHeight(tooltipRef.current.clientHeight);
        }
    }, []);

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <div className="sl-relative sl-inline-flex" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            <div
                ref={tooltipWrapRef}
                className={"sl-tooltip sl-top-0 sl-w-75 sl-flex-col sl-z-10 sl-translate-top-center"}
                style={{
                    display: (!showTooltip && tooltipHeight > 0) ? "none" : "block",
                    top: `-${tooltipHeight + 10}px`,
                    height: `${tooltipHeight + 20}px`
                }}
            >
                <div
                    ref={tooltipRef}
                    className={`sl-relative sl-w-full sl-flex sl-align-center sl-justify-center  ${showTooltip ? '' : 'sl-visibility-hidden'}`}>
                    <div className="sl-rounded-lg sl-bg-gray-900 sl-z-10 sl-py-2 sl-px-3 sl-flex sl-flex-col sl-gap-1">
                        <p className="sl-font sl-text-xs sl-font-medium sl-text-white sl-text-start sl-m-auto">
                            {content}
                        </p>
                    </div>
                    <span
                        className="sl-tooltip-pointer sl-pointer-center sl-left-auto sl-w-3 sl-h-3 sl-bg-gray-900 sl-rounded-1 sl-absolute"/>
                </div>
            </div>
        </div>
    );
};

export default Tooltip;
